import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Button, Dropdown, Grid, Image, Typography } from '@iho-design-system/Loader';

/*
    - chartJs
*/
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip } from 'chart.js';
import { Line } from 'react-chartjs-2';

/*
    - icon
*/
import ChevronDownWhite from '../../assets/images/icons/chevron-down-white.svg';
import LoadingCustomSVG from '../../assets/images/icons/loading-custom.svg';

const Chart = ({ props, ReportTypeProps }) => {

    const [buyAmountReport, setBuyAmountReport] = React.useState('loading');
    const [ReportType, setReportType] = React.useState(1);
    const labels = [];
    const datasetData = [];

    React.useEffect(() => {
        if (props.buyAmountReport.status === 200) {
            setBuyAmountReport(props.buyAmountReport.data);
        }
    }, [props]);

    /*
        - chartConfig
    */
    ChartJS.defaults.font.family = 'YekanBakhFaNum-Regular';
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Tooltip
    );

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: -50
        },
        plugins: {
            tooltip: {
                displayColors: false,
                bodyAlign: 'center',
                bodyColor: '#009EFF',
                borderColor: '#009EFF',
                borderWidth: '1',
                backgroundColor: '#ffffff',
                callbacks: {
                    title: function () { }
                }
            },
        },
        scales: {
            x: {
                grid: {
                    display: true,
                    drawBorder: false,
                    color: '#E7E7F0'
                }
            },
            y: {
                display: false,
                beginAtZero: true,
                grid: {
                    display: true,
                    drawBorder: false,
                    color: '#E7E7F0'
                }
            },
        },
        animations: {
            tension: {
                duration: 5000,
                easing: 'linear',
                from: 0.5,
                to: 0,
                loop: true
            }
        }
    };

    /*
        - chartData
    */
    if (buyAmountReport !== 'loading') {
        buyAmountReport.forEach((obj) => {
            labels.push(obj.name);
        });
        buyAmountReport.forEach((obj) => {
            datasetData.push((obj.amount / 10).toString());
        });
    }

    const data = {
        labels,
        datasets: [
            {
                label: 'میزان خرید',
                data: datasetData,
                borderColor: '#64B5F6',
                pointBackgroundColor: '#FFFFFF',
                pointBorderWidth: '5',
                pointBorderColor: '#64B5F6',
                pointHoverBorderWidth: '5',
            },
        ],
    };

    if (buyAmountReport === 'loading') {
        return (
            <Box className="d-flex justify-content-center align-item-center h-100">
                <Image
                    src={LoadingCustomSVG}
                    ms={{ width: '40px', height: '40px' }}
                />
            </Box>
        );
    }

    return (
        <React.Fragment>
            <Grid>
                <Grid.Wrapper className="bg-white rounded-lg border-solid border-light">
                    <Box
                        className="d-flex justify-content-between align-item-center w-100 px-lg"
                        ms={{ height: '62px' }}>
                        <Typography component="h4" ms={{ fontWeight: 'normal !important' }}>
                            گزارش میزان خرید
                        </Typography>
                        <Box>
                            <Dropdown>
                                <Dropdown.Toggle>
                                    <Button
                                        className="d-flex align-item-center text-md rounded-lg"
                                        variant="filled"
                                        color="primary"
                                        size="sm">
                                                    {ReportType === 1 && <Typography component="small">هفتگی</Typography>}
                                        {ReportType === 2 && <Typography component="small">ماهانه</Typography>}
                                        {ReportType === 3 && <Typography component="small">سالانه</Typography>}
                                        <Image
                                            src={ChevronDownWhite}
                                            ms={{ width: '12px !important', height: '12px !important' }}
                                        />
                                    </Button>
                                </Dropdown.Toggle>
                                <Dropdown.Body
                                    className="pointer"
                                    position="center"
                                    ms={{ width: '100px !important', top: '140% !important' }}>
                                    <Typography onClick={() => { setReportType(3); ReportTypeProps(3); }}>
                                        سالانه
                                    </Typography>
                                    <Box className="my-sm" />
                                    <Typography onClick={() => { setReportType(2); ReportTypeProps(2); }}>
                                        ماهانه
                                    </Typography>
                                    <Box className="my-sm" />
                                    <Typography onClick={() => { setReportType(1); ReportTypeProps(1); }}>
                                        هفتگی
                                    </Typography>
                                </Dropdown.Body>
                            </Dropdown>
                        </Box>
                    </Box>
                    <Box
                        className="mx-auto divider-horizontal divider-light"
                        ms={{ width: '95%' }}
                    />
                    <Grid.Item size="col-12">
                        <Box className="position-relative" ms={{ height: '287px' }}>
                            <Box
                                className="p-sm pt-0 position-absolute"
                                ms={{
                                    width: 'calc(100% + 50px)',
                                    height: '330px',
                                    top: '-30px',
                                    right: '-25px'
                                }}>
                                <Line options={options} data={data} />
                            </Box>
                        </Box>
                    </Grid.Item>
                </Grid.Wrapper>
            </Grid>
        </React.Fragment>
    );
};

export default Chart;